import type { IPublicClientApplication } from '@azure/msal-browser'

export async function signOutClickHandler(instance: IPublicClientApplication, userId: string) {
  if (!userId) {
    return
  }

  const account = instance.getAccount({ homeAccountId: userId })
  if (!account) {
    return
  }

  await instance.logoutRedirect({
    account,
    postLogoutRedirectUri: '/',
  })
}
